export const validateFile = (file, acceptedTypes, maxSizeMB) => {
    const isAcceptedType = acceptedTypes.includes(file.type);
    const isWithinSizeLimit = file.size / 1024 / 1024 < maxSizeMB;
    
    if (!isAcceptedType) {
      return { valid: false, message: `Only ${acceptedTypes.map(t => t.split('/')[1]).join(', ')} files are allowed!` };
    }
    
    if (!isWithinSizeLimit) {
      return { valid: false, message: `File must be smaller than ${maxSizeMB}MB!` };
    }
    
    return { valid: true };
  };